export const LANGUAGE_OPTIONS = [
  { code: "nl", label: "Dutch" },
  { code: "en", label: "English" },
  { code: "de", label: "German" },
  { code: "fr", label: "French" },
  { code: "es", label: "Spanish" },
  { code: "zh", label: "Chinese" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "pt", label: "Portuguese" },
  { code: "ar", label: "Arabic" },
];

const LEGACY_LANGUAGE_MAP = {
  English: "en",
  Dutch: "nl",
  German: "de",
  French: "fr",
  Spanish: "es",
  Chinese: "zh",
  Japanese: "ja",
  Korean: "ko",
  Portuguese: "pt",
  Arabic: "ar",
  en: "en",
  nl: "nl",
  de: "de",
  fr: "fr",
  es: "es",
  zh: "zh",
  ja: "ja",
  ko: "ko",
  pt: "pt",
  ar: "ar",
};

export const normalizeProfileLanguage = (value) => {
  if (!value) return null;
  return LEGACY_LANGUAGE_MAP[value] ?? null;
};

export const ROLE_OPTIONS = [
  "Student",
  "Secretary",
  "Nurse",
  "Medical doctor",
  "Specialist",
];

export const MEDICAL_SPECIALTIES = [
  "Cardiology",
  "Dermatology",
  "Emergency Medicine",
  "Endocrinology",
  "Family Medicine",
  "Gastroenterology",
  "General Surgery",
  "General Medicine",
  "Geriatric Medicine",
  "Elderly medicine",
  "Hematology",
  "Infectious Disease",
  "Internal Medicine",
  "Neurology",
  "Obstetrics and Gynecology",
  "Oncology",
  "Ophthalmology",
  "Orthopedic Surgery",
  "Otolaryngology",
  "Pediatrics",
  "Physical Medicine and Rehabilitation",
  "Primary Care",
  "Psychiatry",
  "Pulmonary Disease",
  "Radiology",
  "Rheumatology",
  "Urology",
];

export const SUGGESTION_HIGHLIGHT_OPTIONS = [
  { id: "blush", label: "Teal", bgcolor: "#E6F5F3", borderColor: "#00DBCC" },
  { id: "green", label: "Green", bgcolor: "#E8F8EC", borderColor: "#43A047" },
  { id: "blue", label: "Blue", bgcolor: "#E8F1FB", borderColor: "#2563EB" },
  { id: "grey", label: "Grey", bgcolor: "#F5F5F5", borderColor: "#777777" },
];

export const DEFAULT_SUGGESTION_HIGHLIGHT = "green";

export const getSuggestionHighlightOption = (id) =>
  SUGGESTION_HIGHLIGHT_OPTIONS.find((option) => option.id === id) ||
  SUGGESTION_HIGHLIGHT_OPTIONS.find(
    (option) => option.id === DEFAULT_SUGGESTION_HIGHLIGHT
  );

export const SUGGESTION_FONT_SIZE_OPTIONS = [
  { id: "small", label: "Small", px: 12 },
  { id: "medium", label: "Medium", px: 14 },
  { id: "large", label: "Large", px: 16 },
  { id: "xlarge", label: "XL", px: 18 },
];

export const DEFAULT_SUGGESTION_FONT_SIZE = "medium";

export const getSuggestionFontSizeOption = (id) =>
  SUGGESTION_FONT_SIZE_OPTIONS.find((option) => option.id === id) ||
  SUGGESTION_FONT_SIZE_OPTIONS.find(
    (option) => option.id === DEFAULT_SUGGESTION_FONT_SIZE
  );
